import ApplicantReview from "./ApplicantReview";

export { ApplicantReview as default };
